import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _67b99ac4 = () => interopDefault(import('../pages/action/index.vue' /* webpackChunkName: "pages/action/index" */))
const _01347356 = () => interopDefault(import('../pages/announcement/index.vue' /* webpackChunkName: "pages/announcement/index" */))
const _42e5c033 = () => interopDefault(import('../pages/complaint/index.vue' /* webpackChunkName: "pages/complaint/index" */))
const _96099a26 = () => interopDefault(import('../pages/home/index.vue' /* webpackChunkName: "pages/home/index" */))
const _2081e7e1 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _5b514ef1 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _80d09872 = () => interopDefault(import('../pages/action/assesment/history/index.vue' /* webpackChunkName: "pages/action/assesment/history/index" */))
const _673dfbef = () => interopDefault(import('../pages/action/assesment/history/_id.vue' /* webpackChunkName: "pages/action/assesment/history/_id" */))
const _996cab8c = () => interopDefault(import('../pages/action/assesment/_slug.vue' /* webpackChunkName: "pages/action/assesment/_slug" */))
const _6602f97c = () => interopDefault(import('../pages/action/_slug.vue' /* webpackChunkName: "pages/action/_slug" */))
const _5ceb59fd = () => interopDefault(import('../pages/announcement/_id.vue' /* webpackChunkName: "pages/announcement/_id" */))
const _1ecb4699 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _d70a0652 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/action",
    component: _67b99ac4,
    name: "action"
  }, {
    path: "/announcement",
    component: _01347356,
    name: "announcement"
  }, {
    path: "/complaint",
    component: _42e5c033,
    name: "complaint"
  }, {
    path: "/home",
    component: _96099a26,
    name: "home"
  }, {
    path: "/news",
    component: _2081e7e1,
    name: "news"
  }, {
    path: "/profile",
    component: _5b514ef1,
    name: "profile"
  }, {
    path: "/action/assesment/history",
    component: _80d09872,
    name: "action-assesment-history"
  }, {
    path: "/action/assesment/history/:id",
    component: _673dfbef,
    name: "action-assesment-history-id"
  }, {
    path: "/action/assesment/:slug?",
    component: _996cab8c,
    name: "action-assesment-slug"
  }, {
    path: "/action/:slug",
    component: _6602f97c,
    name: "action-slug"
  }, {
    path: "/announcement/:id",
    component: _5ceb59fd,
    name: "announcement-id"
  }, {
    path: "/news/:slug",
    component: _1ecb4699,
    name: "news-slug"
  }, {
    path: "/",
    component: _d70a0652,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
